import React from 'react';
import { useField } from 'formik';

import { Attach } from '../composer-env';
import { Scroll, Wrapper } from 'widget/components';

import AttachPreview from './attach-preview/attach-preview';

const AttaсhsPreview = () => {
  const [field] = useField<Attach[]>('attachs');

  return (
    <Scroll>
      <div className="whatcrm-widget-attachs-preview">
        <Wrapper gap={8}>
          {field.value.map((attach, i) => (
            <AttachPreview attach={attach} index={i} key={i} />
          ))}
        </Wrapper>
      </div>
    </Scroll>
  );
};

export default AttaсhsPreview;
